<div class="text" [innerHTML]="blurb | safeHtml"></div>
<div class="email-container">
  <div class="input-group email-input">
    <input class="form-control" placeholder="Email" name="email" [(ngModel)]="email">
  </div>
  <div class="email-button-wrapper">
    <div class="pv-button" (click)="emailer()">{{ signupText }}</div>
  </div>
</div>